module.exports = __webpack_public_path__ + "img/send_sms_sendmagic.cf26a8eb.png";